export const SET_INVOICES = 'SET_INVOICES'
export const SET_INVOICES_TOTAL_LENGTH = 'SET_INVOICES_TOTAL_LENGTH'
export const APPEND_INVOICES = 'APPEND_INVOICES'
export const SET_UNPAID_INVOICES_COUNTER = 'SET_UNPAID_INVOICES_COUNTER'
export const SET_SELECTED_INVOICE = 'SET_SELECTED_INVOICE'
export const SET_SHOW_INVOICE_OPTIONS_MODAL = 'SET_SHOW_INVOICE_OPTIONS_MODAL'
export const SET_SHOW_INVOICE_DATA_MODAL = 'SET_SHOW_INVOICE_DATA_MODAL'
export const SET_SHOW_INVOICE_BILLING_ADDRESS_MODAL = 'SET_SHOW_INVOICE_BILLING_ADDRESS_MODAL'
export const SET_SHOW_INVOICE_RESEND_EMAIL_INFO_MODAL = 'SET_SHOW_INVOICE_RESEND_EMAIL_INFO_MODAL'
export const SET_SHOW_INVOICE_RESEND_EMAIL_MODAL = 'SET_SHOW_INVOICE_RESEND_EMAIL_MODAL'
export const SET_IS_INVOICE_CHANGE_EMAIL = 'SET_IS_INVOICE_CHANGE_EMAIL'
export const SET_SELECTED_INVOICE_ORDER = 'SET_SELECTED_INVOICE_ORDER'
export const SET_SHOW_INVOICE_CANCEL_MODAL = 'SET_SHOW_INVOICE_CANCEL_MODAL'
export const UPDATE_INVOICE_CANCELED = 'UPDATE_INVOICE_CANCELED'
export const SET_INVOICES_STATUS_FILTER = 'SET_INVOICES_STATUS_FILTER'
export const SET_IS_INVOICE_CORRECTION = 'SET_IS_INVOICE_CORRECTION'
